import {DefaultRootState, useSelector} from 'react-redux';

export function useStateContainerName(): string {
    return useSelector((state: DefaultRootState) => state.settings.containerName);
}

export function useStateContainerFacets(): string[] {
    const containerName = useSelector((state: DefaultRootState) => state.settings.containerName);
    return useSelector((state: DefaultRootState) => state.settings.containers[containerName]?.facetFields);
}

export function useStateManualValidation(): boolean {
    return useSelector((state: DefaultRootState) => state.settings.manualValidation);
}

export function useStateTechnicalDetails(): boolean {
    return useSelector((state: DefaultRootState) => state.settings.technicalDetails);
}

export function useStateFieldSpecificSearch(): boolean {
    return useSelector((state: DefaultRootState) => state.settings.fieldSpecificSearch);
}
